import { PromotionsBlock } from "@redotech/redo-model/loyalty/loyalty-page-builder/definition";
import { memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";

export const Promotions = memo(function Promotions({
  title,
  titleColor,
  subtitle,
  subtitleColor,
}: PromotionsBlock) {
  return (
    <Flex dir="column" gap="3xl" px="xl" py="6xl" w="full">
      <Text
        fontSize="2xl"
        fontWeight="bold"
        style={{ fontSize: "32px", color: titleColor || "#000000" }}
      >
        {title || "Special Promotions"}
      </Text>

      <Text fontSize="md" style={{ color: subtitleColor }}>
        {subtitle || "Current offers and upcoming deals"}
      </Text>

      <Flex
        align="center"
        justify="center"
        py="6xl"
        style={{ color: "#888888" }}
      >
        <Text fontSize="lg" fontStyle="italic">
          Coming soon
        </Text>
      </Flex>
    </Flex>
  );
});
